var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "topBar" }, [
    _c("div", { staticClass: "menuStyle" }, [
      _c("img", {
        staticClass: "photo",
        attrs: { src: require("@/assets/images/headerText.png"), alt: "" }
      }),
      _c("span", { staticClass: "time-display" }, [
        _vm._v(_vm._s(_vm.currentTime))
      ]),
      _c("div", { staticClass: "menuTitle" }, [
        _vm.logoPath
          ? _c("img", { attrs: { src: _vm.logoPath, alt: "" } })
          : _vm._e(),
        _vm._v("  "),
        _c("span", { staticClass: "title" }, [
          _vm._v("山西应用科技学院东区食堂")
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }